module.exports = __webpack_public_path__ + "static/media/dg3.4efced2e.jpg";